import type { RumEvent, RumErrorEvent } from '@datadog/browser-rum-slim';
import { useEffect, useRef } from 'react';

import { type Stage } from '@eventbrite/webapp-constants';

export const SESSION_SAMPLE_RATE = 2;
export const APP_TOKEN = '1429889f-7c31-4b1d-a280-e94ec0704262';
export const CLIENT_TOKEN = 'pubf43fcf8de511ce458f04cbdf8dc2deb6';
export const HOMEPAGE_WEBAPP_SERVICE = 'rum--web-homepage-webapp';

let initialized = false;

const initDatadog = async (stage: Stage) => {
    if (initialized) return;

    const { datadogRum } = await import('@datadog/browser-rum-slim');
    datadogRum.init({
        applicationId: APP_TOKEN,
        clientToken: CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: HOMEPAGE_WEBAPP_SERVICE,
        env: stage,
        version: '0.1.0',
        sessionSampleRate: SESSION_SAMPLE_RATE,
        trackUserInteractions: true,
        beforeSend: _filterDatadogError,
    });
    initialized = true;
};

export const _filterDatadogError = (event: RumEvent) => {
    if (event.error) {
        const error = (event as RumErrorEvent).error;
        // filter out error that might be caused by link validation/ pre-fetch rendering from email clicks
        // https://github.com/DataDog/browser-sdk/issues/2715
        const regex = /Object Not Found Matching Id:\d+, MethodName:\w+, ParamCount:\d+/;
        if (regex.test(error.message)) return false;
    }

    return true;
};

export const DatadogInit = ({ stage }: { stage: Stage }) => {
    const initialized = useRef(false);

    useEffect(() => {
        if (initialized.current) {
            return;
        }
        initialized.current = true;

        const initDatadogRUM = async () => {
            await initDatadog(stage);
        };

        initDatadogRUM().catch((error) => {
            console.error('Error initializing Datadog:', error);
        });
    }, []);

    // Render nothing - this component is only included so that the init code
    // above will run client-side
    return null;
};
